module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAANlBMVEX////ghJfCETS+ACbNOFbtt8LuvsjXZHv66u3ZaH/stcDJK0v88/XBCi/OP1zEFzrvwsvHJEUXH4yVAAAAxElEQVR4Ae3YRQKDQBQE0YGeuMH9L5tVNnFgfmFdF3gRtNOqcs4551xV61HepPJt9VpZQZ8KEKKUnb63D/4SRb5K1j/tCxxNkd/kIEUjRykaOalL516GugUQunQnrlL4F1H3AEI3wBBAKAOGuhAVYKhnNWBoWkYGDPWuAYwWMGTDxkyNFjCaSV2v0tqNemL38zRdI6d4BHnejUeA9w/kPSoeId5rgfdzYGcA9hJi9+H3K36H4/fE7gqw7wI79Wpyzjnn3B2bBCFuARezUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/japan.png
// module id = 628
// module chunks = 0